import { ActionReducerMap, ActionReducer } from '@ngrx/store';
import { AppState } from './root.state';

import { userReducer } from './user/user.reducer';
import { spinnerReducer } from '../store/session/spinner/spinner.reducer';
import {modulesReducer} from './modules/modules.reducer';


import { UserState } from './user/user.state';
import { SpinnerState } from '../store/session/spinner/spinner.state';
import { ModulesState } from './modules/modules.state';
import { languageReducer } from './languages/languages.reducer';
import { LanguagesState } from './languages/languages.state';

import { menuReducer } from './session/menu/menu.reducer';
import { Menu } from './session/menu/menu.state';





export const rootReducer: ActionReducerMap<AppState> = {
  user: userReducer as ActionReducer<UserState>,
  spinner: spinnerReducer as ActionReducer<SpinnerState>,
  modules: modulesReducer as ActionReducer<ModulesState>,
  languages: languageReducer as ActionReducer<LanguagesState>,
  //menu: menuReducer as ActionReducer<Menu>

};
